import React from 'react';
// import styles from './Blogs.module.scss';

export const Blogs: React.FC = () => {
  return (
    <section id="blog" className="chapter">
      <h2>ブログ</h2>
    </section>
  );
};
